<template>
  <div class="school-data">
    <div class="school-data__header">
      <div class="school-data__header__left">
        <h1>Skemalagte timer</h1>
        <changeSchoolYear :white-theme="true" class="marg-1-right"></changeSchoolYear>
      </div>
      <div class="school-data__header__right">
        <p class="d-link" @click="resetDates" v-if="!isDatesPristine">{{ $t('vue2.task_overview.reset') }}</p>
        <Datepickerrange
          :startdate="startDate"
          :enddate="endDate"
          @startchanged="setStartDate"
          @endchanged="setEndDate">
        </Datepickerrange>
      </div>
    </div>
    <div class="loader-container" v-if="isLoading">
      <Loader></Loader>
      <h4>Snup en kop kaffe, det kan tage et par minutter</h4>
    </div>
    <template v-else>
      <h2 class="text-explainer" v-if="filteredCalendars.length < 1">Ingen klasser i skoleåret</h2>
      <ul>
        <li v-for="calendar in filteredCalendars" :key="calendar.id">
          <SchoolDataGrade
            :calendar="calendar"
            :eventsInHash="eventsInHash"
          ></SchoolDataGrade>
        </li>
      </ul>
    </template>
  </div>
</template>

<script>
import ChangeSchoolYear from '../School/ChangeSchoolYear'
import SchoolDataGrade from './SchoolDataGrade'
import Loader from '../common/Loader'
import moment from 'moment'
import Datepickerrange from '../datepicker/DatePickerRange'
import schoolDataMixin from '../../mixins/schoolDataMixin'

export default {
  components: {Datepickerrange, Loader, ChangeSchoolYear, SchoolDataGrade},
  mixins: [schoolDataMixin],
  computed: {
    calendars () {
      return this.$store.state.calendars
    },
    isLoadingSchoolCalenders () {
      return this.$store.state.isLoadingSchoolCalenders
    },
    clubCalendars () {
      return this.$store.getters.clubCalendars
    },
    klassCalendars () {
      return this.$store.getters.klassCalendars
    },
    filteredCalendars () {
      const klassCalendars = this.klassCalendars || []
      const clubCalendars = this.clubCalendars || []
      return klassCalendars.concat(clubCalendars)
    },
    reportCalendars () {
      return this.filteredCalendars
    },
    eventsInHash () {
      let eventsInHash = {}
      this.eventsInRange.forEach((event, idx) => {
        event.calendars.forEach(calendarEvent => {
          const calId = calendarEvent.calendar_id
          const durationInMinutes = moment(event.end).diff(moment(event.start), 'minutes')
          event.v_duration = durationInMinutes
          if (calendarEvent.substitute) {
            event.v_has_substitute = true
          }
          if (!eventsInHash[calId]) {
            eventsInHash[calId] = [event]
          } else {
            eventsInHash[calId].push(event)
          }
        })
      })
      return eventsInHash
    }
  }
}
</script>


<style scoped>
@import "../../assets/css/variables.css";

.school-data {
  margin: 1rem;
}

.school-data__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  max-width: 1440px;
  min-width: 1100px;
}

.school-data__header__left {
  display: flex;
  align-items: center;
}

.school-data__header h1 {
  margin-right: 1rem;
}

.loader-container {
  text-align: center;
}

.school-data__header__right {
  display: flex;
  align-items: center;
}


.d-link {
  color: var(--blue);
  cursor: pointer;
  margin-right: 1rem;
}

.d-link:hover {
  text-decoration: underline;
}
</style>



// WEBPACK FOOTER //
// SchoolData.vue?3a481bde